import { toast } from "$global-providers/toast-provider";
import { gql } from "@apollo/client";
import { defineMessage, useIntl } from "react-intl";
import { useCreateInvoiceMutation } from "./__generated__/useCreateInvoice.gql";
import { InvoicesDocument } from "./__generated__/useFetchPatientInvoices.gql";

const ERROR_MESSAGE = defineMessage({
  id: "invoicing.createInvoice.error.msg",
  defaultMessage: "Failed to create a new invoice",
});

gql`
  mutation createInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      _id
      created
      invoiceNumber
      invoiceStatus
      patientType
      createdBy {
        person {
          firstname
          lastname
        }
        uuid
      }
      balance {
        total
        paid
        due
        currency
      }
    }
  }
`;

export default function useCreateInvoice(patientUuid: string) {
  const { formatMessage } = useIntl();

  const [createInvoice] = useCreateInvoiceMutation({
    variables: {
      input: {
        patientUuid,
      },
    },
    onError() {
      toast.error(formatMessage(ERROR_MESSAGE), {});
    },
    update: (cache, res) => {
      try {
        const cachedInvoices = cache.readQuery({
          query: InvoicesDocument,
          variables: { patientUuid },
        });
        if (cachedInvoices) {
          cache.writeQuery({
            query: InvoicesDocument,
            variables: { patientUuid },
            data: {
              // @ts-ignore
              invoices: [res.data.createInvoice, ...cachedInvoices.invoices],
            },
            broadcast: false,
          });
        }
      } catch (_e) {
        // do nothing, guards against scenario where invoices is not in the cache
      }
    },
  });

  return { createInvoice };
}
